var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.463,
    height: 11.581,
    viewBox: "0 0 22.463 11.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye_on",
    "data-name": "eye on",
    transform: "translate(-2229 875.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8081",
    "data-name": "Group 8081",
    transform: "translate(2229 -875.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M11.247,11.581A12.179,12.179,0,0,1,9.868,11.5,14.673,14.673,0,0,1,5.7,10.361a17.647,17.647,0,0,1-3.383-1.88C1.793,8.107,1.287,7.7.792,7.306.581,7.135.362,6.961.145,6.787.114,6.763.084,6.737.052,6.708L0,6.67A21.308,21.308,0,0,1,5.818,1.578,16.652,16.652,0,0,1,7.547.763,9.774,9.774,0,0,1,10.909.006c.1,0,.211-.006.316-.006a9.818,9.818,0,0,1,3.42.642,15.808,15.808,0,0,1,4.5,2.665,22.165,22.165,0,0,1,3.214,3.22c.022.027.043.055.066.085l.04.054a21.387,21.387,0,0,1-5.544,3.693,11.015,11.015,0,0,1-1.7.57l-.094.025a13.524,13.524,0,0,1-2.886.583C11.917,11.566,11.58,11.581,11.247,11.581ZM11.232.98a4.814,4.814,0,1,0,4.814,4.814A4.814,4.814,0,0,0,11.232.98Z",
    fill: "#c0c0c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M3.235,6.471A3.236,3.236,0,1,1,4.261.167,1.578,1.578,0,1,0,6.349,2.35,3.236,3.236,0,0,1,3.235,6.471Z",
    transform: "translate(7.996 2.559)",
    fill: "#c0c0c5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.2913830a6813e28b96b25198c476da23.svg";
export { ForwardRef as ReactComponent };